import { defineMessages } from "@/i18n";
import en from "./en";

export const canvasFeedbackMessages = defineMessages("canvas-feedback", en);
